import { useMultiContract, useProvider } from './useContract'
import useEnvConfig from 'hooks/useEnvConfig'
import { ABI_COCOS_DIVIDEND_TEAM, ABI_COCOS_POWER } from '../utils/abis'
import { useEffect, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { BigNumber } from 'ethers'
import { formatEther } from 'ethers/lib/utils'

const heroIds = [999991, 999992, 999993, 999994, 999995, 999996, 999997, 999999]

export default function useMyPower() {
  const envConfig = useEnvConfig()
  const teamContract = useMultiContract(envConfig.ADDRESS_COCOSDIVIDENDSTEAM, ABI_COCOS_DIVIDEND_TEAM)
  const powerContract = useMultiContract(envConfig.ADDRESS_COCOS_POWER, ABI_COCOS_POWER)
  const { account } = useWeb3React()
  const provider = useProvider()
  const [cocosPower, setCocosPower] = useState(0)
  const [totalPower, setTotalPower] = useState(0)
  useEffect(() => {
    if (teamContract && powerContract && account && provider) {
      provider
        .all([
          ...heroIds.map((id) => teamContract.getAccBalances(id, account)),
          ...heroIds.map((id) => teamContract.getAccPowerBalances(id, account)),
        ])
        .then((res: BigNumber[]) => {
          const cocosp = +res
            .slice(0, 8)
            .map((x) => +formatEther(x))
            .reduce((x, y) => x + y, 0)
          const total = +res
            .slice(8)
            .map((x) => +formatEther(x))
            .reduce((x, y) => x + y, 0)
          setCocosPower(+cocosp.toFixed(4))
          setTotalPower(+total.toFixed(4))
        })
    }
  }, [teamContract, provider, powerContract, account])
  return { cocosPower, totalPower }
}
